var AgentPayoutMethod = {
    BKASH: 1,
    NAGAD: 2,
    ROCKET: 3,
}

export { AgentPayoutMethod }
